import { COUNTRY_CODES } from '@/constants/country-codes';
import { CurrencyInfo, ExchangeRate } from '@/core/currency/interfaces';

export const DEFAULT_CURRENCY_FORMAT_PATTERN = '0,0[.]00';

export const CURRENCY_CODE = {
    Bgn: '975',
    Ron: '946',
    Kuna: '191',
    Euro: '978',
    Pound: '826',
    Zloty: '985',
    Krone: '208',
    Forint: '348',
    Koruna: '203',
    SwedenKrona: '752',
    NorwegianKrone: '578'
};

export const CURRENCY: { [key: string]: CurrencyInfo } = {
    [CURRENCY_CODE.Bgn]: {
        name: 'BGN',
        symbol: 'лв',
        format: 'gr',
        code: 975
    },
    [CURRENCY_CODE.Ron]: {
        name: 'RON',
        symbol: 'lei',
        format: 'gr',
        code: 946
    },
    [CURRENCY_CODE.Kuna]: {
        name: 'HRK',
        symbol: 'kn',
        format: 'gr',
        code: 191
    },
    [CURRENCY_CODE.Euro]: {
        name: 'EUR',
        symbol: '€',
        format: 'gr',
        code: 978
    },
    [CURRENCY_CODE.Pound]: {
        name: 'GBP',
        symbol: '£',
        format: 'en',
        code: 826
    },
    [CURRENCY_CODE.Zloty]: {
        name: 'PLN',
        symbol: 'zł',
        format: 'gr',
        code: 985
    },
    [CURRENCY_CODE.Krone]: {
        name: 'DKK',
        symbol: 'kr',
        format: 'gr',
        code: 208
    },
    [CURRENCY_CODE.Forint]: {
        name: 'HUF',
        symbol: 'ft',
        format: 'gr',
        code: 348
    },
    [CURRENCY_CODE.Koruna]: {
        name: 'CZK',
        symbol: 'Kč',
        format: 'gr',
        code: 203
    },
    [CURRENCY_CODE.SwedenKrona]: {
        name: 'SEK',
        symbol: 'SEK', // The swedish currency symbol is kr but we had a request from product to change it to SEK
        format: 'gr',
        code: 752
    },
    [CURRENCY_CODE.NorwegianKrone]: {
        name: 'NOK',
        symbol: 'NOK',
        format: 'gr',
        code: 578
    }
};

export const DEFAULT_CURRENCY = CURRENCY_CODE.Euro;

export const COUNTRY_CURRENCY: { [key: string]: string } = {
    [COUNTRY_CODES.Bulgarian]: CURRENCY_CODE.Bgn,
    [COUNTRY_CODES.Croatia]: CURRENCY_CODE.Kuna,
    [COUNTRY_CODES.CzechRepublic]: CURRENCY_CODE.Koruna,
    [COUNTRY_CODES.Denmark]: CURRENCY_CODE.Krone,
    [COUNTRY_CODES.GreatBritain]: CURRENCY_CODE.Pound,
    [COUNTRY_CODES.Hungary]: CURRENCY_CODE.Forint,
    [COUNTRY_CODES.Poland]: CURRENCY_CODE.Zloty,
    [COUNTRY_CODES.Romania]: CURRENCY_CODE.Ron,
    [COUNTRY_CODES.Sweden]: CURRENCY_CODE.SwedenKrona,
    [COUNTRY_CODES.Norway]: CURRENCY_CODE.NorwegianKrone
};

export const EXCHANGE_RATES: { [key: string]: ExchangeRate } = {
    [CURRENCY_CODE.Kuna]: {
        currency: CURRENCY[CURRENCY_CODE.Euro],
        rate: (1 / 7.53450)
    },
    [CURRENCY_CODE.Bgn]: {
        currency: CURRENCY[CURRENCY_CODE.Euro],
        rate: (1 / 1.95583)
    }
};

export const BULGARIAN_EXCHANGE_RATE: ExchangeRate = {
    currency: CURRENCY[CURRENCY_CODE.Bgn],
    rate: 1.95583
};
